"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = void 0;
var Errors;
(function (Errors) {
    Errors["NO_FALLBACK_FOUND"] = "no_fallback_found";
    Errors["NO_INTERNATIONALIZATION_FOUND"] = "no_internationalization_found";
    Errors["NO_CATEGORY"] = "no_category";
    Errors["NO_CONVERTED_LOCALE"] = "NO_CONVERTED_LOCALE";
    Errors["INVALID_PARAMETERS"] = "invalid-parameters";
    Errors["INVALID_BODY"] = "invalid-body";
    Errors["MISSING_BODY"] = "missing-body";
    Errors["VALIDATION_ERROR"] = "validation-error";
    Errors["NOT_AUTHORIZED"] = "not-authorized";
    Errors["TOO_MUCH_BIG_RESPONSE"] = "too-much-big-response";
    Errors["DENIED_DEFAULT_PROVIDER_REMOVAL"] = "denied-default-provider-removal";
    Errors["DENIED_CURRENT_PROVIDER_REMOVAL"] = "denied-current-provider-removal";
    Errors["INVALID_EMAIL_SENDING"] = "error_email_not_send";
    Errors["FILE_NOT_FOUND"] = "file_not_found";
    Errors["CAPTCHA_NOT_VALIDATED"] = "captcha-not-validated";
    Errors["REWRITE_ERROR_INSERT"] = "rewrite-error-insert";
    Errors["REWRITE_ERROR_DELETE"] = "rewrite-error-delete";
})(Errors = exports.Errors || (exports.Errors = {}));
//# sourceMappingURL=errors.js.map